/// <amd-module name="VSS/Reflux/Action" />
export type ActionListener<T> = (payload: T) => void;
const DEFAULT_SCOPE = "DEFAULT_SCOPE";
export class Action<T> {
    /**
     * A mutex to ensure that only one action in a given scope is executing executing at any time.
     * This prevents cascading actions within scope.
     */
    private static executingScopes: { [key: string]: boolean } = {};
    private _scope: string;

    private listeners: ActionListener<T>[] = [];

    /**
     * Create a new action
     * @param scope The scope that this action should execute in. Actions with the same scope cannot be invoked within each other
     */
    constructor(scope: string = DEFAULT_SCOPE) {
        this._scope = scope;
    }

    public invoke(payload: T): void {
        if (Action.executingScopes[this._scope]) {
            throw new Error(`Cannot invoke an action with scope ${this._scope} from inside another action with the same scope`);
        }

        Action.executingScopes[this._scope] = true;

        try {
            this.listeners.forEach(listener => {
                listener(payload);
            });
        } finally {
            delete Action.executingScopes[this._scope];
        }
    }

    /**
     * Add listener to the action
     * @param listener Listener to add
     */
    public addListener(listener: ActionListener<T>): void {
        this.listeners.push(listener);
    }

    /**
     * Remove listener from the action
     * @param listener Listener to remove
     */
    public removeListener(listener: ActionListener<T>): void {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    }
}
